import Vue from 'vue';

export default class AlertService {
  public showError(instance: Vue, message: string, params?: any) {
    const alertMessage = message;
    (instance.$root as any).$bvToast.toast(alertMessage.toString(), {
      toaster: 'b-toaster-top-center',
      title: 'Error',
      variant: 'danger',
      solid: true,
      autoHideDelay: 5000,
    });
  }

  public showSuccess(instance: Vue, message: string, params?: any) {
    const alertMessage = message;
    (instance.$root as any).$bvToast.toast(alertMessage.toString(), {
      toaster: 'b-toaster-top-center',
      title: 'Success',
      variant: 'success',
      solid: true,
      autoHideDelay: 5000,
    });
  }

  public getHttpError(instance: Vue, httpErrorResponse: any) {
    switch (httpErrorResponse.status) {
      case 0:
        return 'Server not reachable';

      case 400: {
        const arr = Object.keys(httpErrorResponse.headers);
        let errorHeader: string | null = null;
        for (const entry of arr) {
          if (entry.toLowerCase().endsWith('app-error')) {
            errorHeader = httpErrorResponse.headers[entry];
          }
        }
        if (errorHeader) {
          return errorHeader;
        } else if (httpErrorResponse.data !== '' && httpErrorResponse.data.fieldErrors) {
          return 'Validation error';
        } else {
          return httpErrorResponse.data.message;
        }
      }

      case 404:
        return 'Not found';

      case 500:
        // Handle Database Errors
        if (httpErrorResponse.data.status === 'Database Error') {
            return this.handleDatabaseErrors(httpErrorResponse.data.message);
        } else {
            return httpErrorResponse.data.message;
        }

      case 504:
        return 'Gateway Timeout: Cannot connect to API Server'

      default:
        return httpErrorResponse.data.message;
    }
  }

  public showHttpError(instance: Vue, httpErrorResponse: any) {
    let response = this.getHttpError(instance, httpErrorResponse)
    this.showError(instance, response);
  }

  public handleDatabaseErrors (message: any) {
    if (message.function) {
      return 'The database function "' + message.function + '" failed to run with Error Code: "' + message.code + '": ' + message.message;
    } else {
      switch (message.code) {
        case "23505" :
          if (typeof message.constraint === 'string') {
            let constraintArr = message.constraint.split('_')
            return 'A ' + constraintArr[0] + ' with that ' + constraintArr[1] + ' already exists.'
          } else {
            return 'A database entry with these details already exists: ( ' +  message.detail + ' ).'
          }

        default :
        let response = 'Database Error "' + message.code + '": ' + message.message;
          return response;
    }
  }
}

}
